module.exports = __webpack_public_path__ + "img/sustainability@2x.4d63b9a.jpg";